import React from "react";
import Navbar from "./Components/NavBar";
import HeroSection from "./Components/HeroSection";
import FeaturedCompanies from "./Components/FeaturedCompanies";
import FeaturedByCompanies from "./Components/FeaturedByCompanies";
import BookChapters from "./Components/BookChapters";
import OurWorkCarousel from "./Components/OurWorkSample";
import TestimonialCarousel from "./Components/TestimonialCarousel";
import OtherBooks from "./Components/Books";
import Footer from "./Components/Footer";

const App = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
      {/* <FeaturedCompanies /> */}
      <FeaturedByCompanies />
      <BookChapters />
      <OtherBooks />

      {/* <OurWorkCarousel /> */}
      <TestimonialCarousel />
      <Footer />
    </div>
  );
};

export default App;
